/**
 * Traced upgrade modal entry — all user-facing Upgrade CTAs should route here
 * (via useUpgradeModal().openUpgradeModal or dispatchOpenUpgradeModal).
 */

import type { OpenUpgradeModalOptions } from '@/lib/monetization/useUpgradeModal'

export const WAGAMOUR_OPEN_UPGRADE_MODAL_EVENT = 'wagamour:openUpgradeModal'

export function logUpgradeCtaClick(source: string, feature: string): void {
  console.log(
    '[UpgradeTrace9419bd7] UPGRADE_CTA_CLICK ' +
      JSON.stringify({ source, feature })
  )
}

export function logUpgradeModalOpenCall(source: string, feature: string): void {
  console.log(
    '[UpgradeTrace9419bd7] UPGRADE_MODAL_OPEN_CALL ' +
      JSON.stringify({ source, feature })
  )
}

export function logUpgradeModalProviderOpen(source: string, feature: string): void {
  console.log(
    '[UpgradeTrace9419bd7] UpgradeModalProvider.open ' +
      JSON.stringify({ source, feature })
  )
}

/** Dispatch to UpgradeModalProvider (non-React callers). Logging happens in openUpgradeModal. */
export function dispatchOpenUpgradeModal(options: OpenUpgradeModalOptions): void {
  if (typeof window === 'undefined') return
  window.dispatchEvent(
    new CustomEvent(WAGAMOUR_OPEN_UPGRADE_MODAL_EVENT, { detail: options })
  )
}
